module.exports = __webpack_public_path__ + "img/footer-mockups-right.6094f76.png";